import styled from "styled-components";
import { mediaMaxWidth } from "../../../../utils/mediaQueriesTemplate";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 10px;
  height: calc(100% - 40px);

  ${mediaMaxWidth.phone`
    padding: 0;
  `}
`;

export const Form = styled.form`
  width: 500px;
  height: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;

  ${mediaMaxWidth.tablet`
    width: 400px;
  `}

  ${mediaMaxWidth.phone`
    width: 85vw;
  `}
`;

export const Label = styled.div`
  color: #333;
  font-size: 0.9em;
  margin: 10px 0;

  span {
    font-weight: 700;
  }

  ${mediaMaxWidth.phone`
    font-size: 0.85em;
  `}
`;

export const TextInput = styled.textarea`
  display: flex;
  border: 2px solid #e7e7e7;
  border: ${(props) => props.error !== null && "2px solid #79D9D9"};
  border-radius: 4px;
  width: 100%;
  resize: none;
  height: 10em;
  padding: 10px;
  position: relative;
  margin: 30px 0;

  ::placeholder {
    opacity: 0.75;
    font-weight: 300;
    font-style: italic;
  }

  &:focus {
    border-color: #79D9D9;
    outline: none;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
      0 0 8px rgba(233, 102, 163, 0.6);
  }

  ${mediaMaxWidth.phone`
    margin: 10px 0 40px 0;
    height: 9em;
    padding: 10px;
  `}
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: center;

  button {
    margin: 5px 10px;
  }
`;

export const Field = styled.div`
  position: relative;

  .__react_component_tooltip {
    margin-left: 0;

    ${mediaMaxWidth.phone`
      display: none;
    `}
  }
`;

export const Filename = styled.div`
  max-width: 380px;
  position: absolute;
  top: 15px;
  left: 50px;
  white-space: nowrap;
  overflow: hidden;
  font-weight: 700;
  text-overflow: ellipsis;
  transition: 0.1s ease-in-out;
  pointer-events: none;
  position: absolute;
  color: #fff;

  ${mediaMaxWidth.tablet`
    max-width: 300px;
  `}

  ${mediaMaxWidth.phone`
    max-width: calc(100vw - 150px);
    font-size: 0.85em;
    top: 17px;
    left: 46px;
  `}

  ${mediaMaxWidth.smallPhone`
    max-width: calc(100vw - 140px);
  `}
`;

export const FileInputLabel = styled.label`
  cursor: pointer;
  width: 100%;
  background-color: ${(props) => (props.fileAttached ? "#27AE60" : "#b8b8b8")};
  padding: 10px 15px;
  border-radius: 4px;
  font-size: 1.4em;
  margin-bottom: 50px;
  transition: 0.1s ease-in-out;
  color: #fff;

  &:hover {
    background-color: ${(props) =>
      props.fileAttached ? "#27AE60" : "#79D9D9"};
  }

  ${mediaMaxWidth.phone`
    margin-bottom: 20px;
  `}
`;

export const FileInput = styled.input`
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;

  & + ${FileInputLabel} {
    font-size: 1.25em;
    font-weight: 700;
    color: white;
    background-color: black;
    display: inline-block;
  }
`;

export const RemoveAttachment = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  font-size: 1.4em;
  padding: 10px 15px;
  color: #fff;
  cursor: pointer;
  z-index: 2;
`;

export const Error = styled.div`
  position: absolute;
  bottom: 10px;
  font-size: 0.75em;
  width: 100%;
  text-align: center;
  color: #79D9D9;
  font-weight: 600;

  ${mediaMaxWidth.phone`
    bottom: 5px;
  `}

  ${mediaMaxWidth.smallPhone`
    bottom: 1px;
    font-size: 0.7em;
  `}
`;
